import { Attrs, MinzeElement } from 'minze'

export interface LvcCharlieWavingIcon {
  width?: number
  height?: number
}

export class LvcCharlieWavingIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 432],
    ['height', 262],
  ]
  html = () => `
    <img loading="eager" width="${this.width}" height="${this.height}" src='https://cloud.squidex.io/api/assets/lvc-dev/880799d3-8e39-49f9-bb3a-6a0416637550/salutations.png?version=0&auto=true' />
  `
  css = () => `

  `
}
